import { render } from "./MdRadio.vue?vue&type=template&id=d3048b1a&scoped=true&ts=true"
import script from "./MdRadio.vue?vue&type=script&lang=ts"
export * from "./MdRadio.vue?vue&type=script&lang=ts"

import "./MdRadio.vue?vue&type=style&index=0&id=d3048b1a&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3048b1a"]])

export default __exports__